<template>
    <div>
        <div class="stateroomDetail-t stateroomDetail-t2 js-returnDetailBtn">
            <a class="stateroomDetail-returnButton" @click="goBack">
                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png">
            </a>
            <p class="stateroomDetail-t-title">支付订单</p>
        </div>
        <div class="page-content infinite-scroll page-content-ptb" :class="{'is-integral': totalIntegral && totalValuation}" v-show="bookings.length > 0">
<!--            <div class="count-down scroll-container">-->
<!--                您已下单成功，由于客房紧张，该订单将保留到<span>{{finalPaymentTime}}</span>-->
<!--            </div>-->
            <div class="guest-header" style="padding-top: 6px" :class="[showCountDown == true?'':'slow-height']">
              <img class="logo" :src="`${logoImgUrl}/logoAnchorWhite.png`"/>
              <template v-if="showCountDown">
                <div class="row-1">您已下单成功，由于客房紧张，该订单将保留到</div>
                <div class="row-2"><span>{{finalPaymentTime}}</span></div>
              </template>
            </div>

            <div class="order scroll-container">
                <div class="route-info">
                    <div class="route-name">
                        {{paymentBookings.cruiseName}}
                    </div>

                    <div class="route-ship">{{paymentBookings.cruiseDateNight}} {{paymentBookings.shipName}}</div>
                    <div class="route-row">
                        <div class="route-row-txt">{{paymentBookings.sailDateBegin}} - {{paymentBookings.sailDateEnd}}</div>
                    </div>
                    <div class="route-row">
                        <div class="route-row-title">联 系 人</div>
                        <div class="route-row-txt">
                            ：{{contactName}}
                        </div>
                    </div>
                    <div class="route-row2">
                        <div class="route-row2-txt">{{contact.telephone}}</div>
                        <div class="route-row2-txt">{{contact.email}}</div>
                    </div>

                    <div class="order-line"></div>
                </div>

                <div class="cabinItem-wrap">
                    <div class="cabinItem active" v-for="(booking, i) in normalBookings" :key="('normalBooking_' + i)">
                        <div class="cabinItem-m ">
                            <div class="cabinItem-title">
                                <div class="cabinItem-title-num">
                                    <div class="cabinItem-title-num-txt1">船票预订号:</div>
                                    <div class="cabinItem-title-num-txt2">{{booking.bookingId}}</div>
                                </div>
                            </div>
                            <div class="cabinItem-box" @click="goToDetail(booking.encBookingId)">
                                <div class="cabinItem-img">
                                    <img class="" :src="getStateroomImage(booking)">
                                </div>
                                <div class="cabinItem-info">
                                    <div class="cabinItem-info-title">
                                        <div class="cabinItem-info-title-l">{{getStateroomName(booking)}}</div>
                                    </div>
                                    <div class="cabinItem-info-brief">
                                        {{getGuests(booking).length}}人
                                        | {{getStateroom(booking).areaInfo}}
                                        | {{getBalconyArea(booking)}}
                                    </div>
                                    <div class="cabinItem-info-num  ">
                                        房间号：{{booking.stateroomNumber == 'GTY' ? '随机房间号': booking.stateroomNumber}}
                                      <img v-if="booking.groupType == 'QIAOHU' || booking.groupType == 'QIAOHU_AL'"
                                           @click.stop.prevent="isShowQiaohuPopup = true" class="QIAOHU_CSS qiaohu_tag"
                                           src="https://resource.rcclchina.com.cn/QIAOHU/Mobile_QIAOHU.jpg">
                                      <img v-else-if="booking.groupType == 'STARRYSKY'"
                                           @click.stop.prevent="isShowStarrySkyPopup = true" class="QIAOHU_CSS qiaohu_tag"
                                           src="https://resource.rcclchina.com.cn/STARRYSKY/MB_icon.png">
                                      <img v-else-if="booking.groupType === 'PCPGIFT'"
                                           @click.stop.prevent="showCustomThemePopup(booking.personalizedStateroomInfo)"
                                           class="PCP_GIFT_THEME_CSS qiaohu_tag"
                                           :src="booking.personalizedStateroomInfo?.roomIconImage">
                                      <img v-else-if="booking.groupType == 'CUSTOM'"
                                           @click.stop.prevent="showCustomThemePopup(booking.personalizedStateroomInfo)" class="CUSTOM_THEME_CSS qiaohu_tag"
                                           :src="booking.personalizedStateroomInfo?.roomIconImage">
                                    </div>
                                    <div class="cabinItem-info-name">{{getGuestsNameStr(booking)}}</div>
                                    <div class="cabinItem-price">
                                      <span class="unit">¥</span>{{getBookingPay(booking).amount}}
                                    </div>
                                </div>
                            </div>
                            <div v-if="getUnFilledGuest(booking)" class="cabinItem-un-filled">
                              <img class="icon" :src="`${imgUrl}/icons/icon-warning-triangle.png`"/>
                              <div class="text">暂未完成全部乘客信息填写，建议开航<span class="fc-red">45</span>天前至“我的订单”补全，开航前<span class="fc-red">7</span>天及以内不可再进行修改</div>
                            </div>
                            <div class="cabinItem-deposit" v-if="getBookingPay(booking).isDownPayCruise && getBookingPay(booking).downPayAmount > 0">
                                <div class="cabinItem-deposit-l">
                                    支付订金（¥{{getBookingPay(booking).downPayAmount}}）
                                    <img class="downpay_icon" @click="showDownpayPopup(booking)" src="https://resource.rcclchina.com.cn/RcclHP/icon08.png" />
                                </div>
                                <div class="cabinItem-deposit-r">
                                    <div class="item-input">
                                        <label class="label-switch">
                                            <input type="checkbox" class="js-depositHook">
                                            <div class="checkbox js-depositCheckbox" @click="setBookingDownpay($event, booking)"></div>
                                        </label>
                                    </div>
                                </div>
                            </div>
<!--                            <div v-if="getBookingIntegral(booking).length > 0" class="cabinItem-jifen">下船后预计送 <span>{{getBookingIntegral(booking)}}</span> 积分-->
<!--                                <img src="https://resource.rcclchina.com.cn/RcclHP/icon08.png" @click="showBookingIntegralTips()"> -->
<!--                                <br/>-->
<!--                                可至积分商城兑换价值约<span>{{getBookingIntegralValue(booking)}}</span>元电话卡-->
<!--                            </div>-->
                        </div>
                        <PcpGiftView v-if="booking.groupType==='PCPGIFT'"
                                     :giftInfo="booking?.personalizedStateroomInfo"
                                     :shipCode="booking.shipCode"
                                     :sailDate="booking.sailDate"
                                     :guestNumber="booking.bookingGuests.length"
                                     @open="showCustomThemePopup"
                                     is-on-page-popup
                                     pageName="Pay"></PcpGiftView>
                        <div class="order-line"></div>
                    </div>

                    <div v-for="(connectBooking, i) in connectBookings" :key="('connectBookings_' + i)">
                        <div class="cabinItem active" v-for="(booking, j) in connectBooking.bookings" :key="('connectBookings_' + i) + '_'+j">
                            <div class="cabinItem-m c_cabinItem-wrap " :class="{ 'c_first_room': j==0, 'c_second_room': j==1}">
                                <div class="cabinItem-title">
                                    <div class="cabinItem-title-num">
                                        <div class="cabinItem-title-num-txt1">船票预订号:</div>
                                        <div class="cabinItem-title-num-txt2">{{booking.bookingId}}</div>
                                    </div>
                                </div>

                                <div class="cabinItem-box" @click="goToDetail(booking.encBookingId)">
                                    <div class="cabinItem-img">
                                        <a class="external">
                                            <img class="" :src="getStateroomImage(booking)">
                                        </a>
                                    </div>
                                    <div class="cabinItem-info">
                                        <div class="cabinItem-info-title">
                                            <div class="cabinItem-info-title-l">{{getStateroomName(booking)}}</div>
                                        </div>
                                        <div class="cabinItem-info-brief">
                                            {{getGuests(booking).length}}人
                                            | {{getStateroom(booking).areaInfo}}
                                            | {{getBalconyArea(booking)}}
                                        </div>
                                        <div class="cabinItem-info-num  Connectroom-info-num">
                                            房间号：{{booking.stateroomNumber == 'GTY' ? '随机房间号': booking.stateroomNumber}}
                                            <br>
                                            <img v-if="booking.groupType == 'QIAOHU' || booking.groupType == 'QIAOHU_AL'"
                                                @click.stop.prevent="isShowQiaohuPopup = true" class="QIAOHU_CSS qiaohu_tag"
                                                src="https://resource.rcclchina.com.cn/QIAOHU/Mobile_QIAOHU.jpg">
                                            <img v-else-if="booking.groupType == 'STARRYSKY'"
                                                @click.stop.prevent="isShowStarrySkyPopup = true" class="QIAOHU_CSS qiaohu_tag"
                                                src="https://resource.rcclchina.com.cn/STARRYSKY/MB_icon.png">
                                          <img v-else-if="booking.groupType === 'PCPGIFT'"
                                               @click.stop.prevent="showCustomThemePopup(booking.personalizedStateroomInfo)"
                                               class="PCP_GIFT_THEME_CSS qiaohu_tag"
                                               :src="booking.personalizedStateroomInfo?.roomIconImage">
                                            <img v-else-if="booking.groupType == 'CUSTOM'"
                                               @click.stop.prevent="showCustomThemePopup(booking.personalizedStateroomInfo)" class="CUSTOM_THEME_CSS qiaohu_tag"
                                               :src="booking.personalizedStateroomInfo?.roomIconImage">
                                            <img class="CONNECT_CSS" @click="showConnectRoomPopup()"
                                                src="https://resource.rcclchina.com.cn/ConnectStateroom/Mobile_ConnectIcon.png"
                                                style="width: auto;" alt="">
                                        </div>
                                        <div class="cabinItem-info-name">{{getGuestsNameStr(booking)}}</div>
                                        <div class="cabinItem-price">
                                          <span class="unit">¥</span>{{getBookingPay(booking).amount}}
                                        </div>
                                    </div>
                                </div>
                                <div class="cabinItem-deposit" v-if="getBookingPay(booking).isDownPayCruise && getBookingPay(booking).downPayAmount > 0">
                                    <div class="cabinItem-deposit-l">
                                        支付订金（¥{{getBookingPay(booking).downPayAmount}}）
                                        <img class="downpay_icon" @click="showDownpayPopup(booking)" src="https://resource.rcclchina.com.cn/RcclHP/icon08.png" />
                                    </div>
                                    <div class="cabinItem-deposit-r">
                                        <div class="item-input">
                                            <label class="label-switch">
                                                <input type="checkbox" class="js-depositHook">
                                                <div class="checkbox js-depositCheckbox" @click="setBookingDownpay($event, booking)"></div>
                                            </label>
                                        </div>
                                    </div>
                                </div>

<!--                                <div v-if="getBookingIntegral(booking).length > 0" class="cabinItem-jifen">下船后预计送 <span>{{getBookingIntegral(booking)}}</span> 积分-->
<!--                                    <img src="https://resource.rcclchina.com.cn/RcclHP/icon08.png" @click="showBookingIntegralTips()"> -->
<!--                                    <br/>-->
<!--                                    可至积分商城兑换价值约<span>{{getBookingIntegralValue(booking)}}</span>元电话卡-->
<!--                                </div>-->
                                <div class="c_wrap" v-if="j==0">
                                    <img class="c_img_conpay" src="https://resource.rcclchina.com.cn/cruiseDetail/mb_connect_info.png">
                                </div>
                            </div>
                            <PcpGiftView v-if="booking.groupType==='PCPGIFT'"
                                       :giftInfo="booking?.personalizedStateroomInfo"
                                       :shipCode="booking.shipCode"
                                       :sailDate="booking.sailDate"
                                       :guestNumber="booking.bookingGuests.length"
                                       @open="showCustomThemePopup"
                                       is-on-page-popup
                                       pageName="Pay"></PcpGiftView>
                            <div class="order-line"></div>
                        </div>

                    </div>
                </div>

                <div class="order-line mergeTip-order-line"></div>
                <div class="mergeTip" :class="{ active: !isHideNoPayBooking}" @click="isHideNoPayBooking=!isHideNoPayBooking" v-if="noPayBookings.length > 0">
                    <div class="mergeTip-txt">
                        同航线还有未付款订单，是否要合并付款？
                    </div>
                    <img class="mergeTip-arrow" src="https://resource.rcclchina.com.cn/RcclHP/BOOKING/icon15.png">
                </div>
                <div class="meargeCabin" v-if="noPayBookings.length > 0" v-show="!isHideNoPayBooking">
                    <div class="cabinItem" v-for="(booking, i) in noPayBookings"
                    :key="('noPayBooking_' + i)"
                    :class="{ active: booking.isSelected}"
                    >
                        <div class="cabinItem-icon js-cabinItem" @click="booking.isSelected = !booking.isSelected">
                            <img src="https://resource.rcclchina.com.cn/RcclHP/BOOKING/icon10.png">
                        </div>
                        <div class="cabinItem-m">
                            <div class="cabinItem-title js-cabinItem">
                                <div class="cabinItem-title-num">
                                    <div class="cabinItem-title-num-txt1">船票预订号:</div>
                                    <div class="cabinItem-title-num-txt2">{{booking.bookingId}}</div>
                                </div>
                            </div>

                            <div class="cabinItem-box" @click="goToDetail(booking.encBookingId)">
                                <div class="cabinItem-img">
                                    <a class="external">
                                        <img class="" :src="getStateroomImage(booking)">
                                    </a>
                                </div>
                                <div class="cabinItem-info">
                                    <div class="cabinItem-info-title">
                                        <div class="cabinItem-info-title-l">{{getStateroomName(booking)}}</div>
                                    </div>
                                    <div class="cabinItem-info-brief">
                                        {{getGuests(booking).length}}人
                                        | {{getStateroom(booking).areaInfo}}
                                        | {{getBalconyArea(booking)}}
                                    </div>
                                    <div class="cabinItem-info-num  ">
                                        房间号：{{booking.stateroomNumber == 'GTY' ? '随机房间号': booking.stateroomNumber}}
                                      <img v-if="booking.groupType == 'QIAOHU' || booking.groupType == 'QIAOHU_AL'"
                                           @click.stop.prevent="isShowQiaohuPopup = true" class="QIAOHU_CSS qiaohu_tag"
                                           src="https://resource.rcclchina.com.cn/QIAOHU/Mobile_QIAOHU.jpg">
                                      <img v-else-if="booking.groupType == 'STARRYSKY'"
                                           @click.stop.prevent="isShowStarrySkyPopup = true" class="QIAOHU_CSS qiaohu_tag"
                                           src="https://resource.rcclchina.com.cn/STARRYSKY/MB_icon.png">
                                      <img v-else-if="booking.groupType === 'PCPGIFT'"
                                           @click.stop.prevent="showCustomThemePopup(booking.personalizedStateroomInfo)"
                                           class="PCP_GIFT_THEME_CSS qiaohu_tag"
                                           :src="booking.personalizedStateroomInfo?.roomIconImage">
                                      <img v-else-if="booking.groupType == 'CUSTOM'"
                                           @click.stop.prevent="showCustomThemePopup(booking.personalizedStateroomInfo)" class="CUSTOM_THEME_CSS qiaohu_tag"
                                           :src="booking.personalizedStateroomInfo?.roomIconImage">
                                    </div>
                                    <div class="cabinItem-info-name">{{getGuestsNameStr(booking)}}</div>
                                    <div class="cabinItem-price">
                                      <span class="unit">¥</span>{{getBookingPay(booking).amount}}
                                    </div>
                                </div>
                            </div>
                            <div class="cabinItem-deposit" v-if="getBookingPay(booking).isDownPayCruise && getBookingPay(booking).downPayAmount > 0">
                                <div class="cabinItem-deposit-l">
                                    支付订金（¥{{getBookingPay(booking).downPayAmount}}）
                                    <img class="downpay_icon" @click="showDownpayPopup(booking)" src="https://resource.rcclchina.com.cn/RcclHP/icon08.png" />
                                </div>
                                <div class="cabinItem-deposit-r">
                                    <div class="item-input">
                                        <label class="label-switch">
                                            <input type="checkbox" class="js-depositHook">
                                            <div class="checkbox js-depositCheckbox" @click="setBookingDownpay($event, booking)"></div>
                                        </label>
                                    </div>
                                </div>
                            </div>

<!--                            <div v-if="getBookingIntegral(booking).length > 0" class="cabinItem-jifen">下船后预计送 <span>{{getBookingIntegral(booking)}}</span> 积分-->
<!--                                <img src="https://resource.rcclchina.com.cn/RcclHP/icon08.png" @click="showBookingIntegralTips()"> -->
<!--                                <br/>-->
<!--                                可至积分商城兑换价值约<span>{{getBookingIntegralValue(booking)}}</span>元电话卡-->
<!--                            </div>-->
                          <PcpGiftView v-if="booking.groupType==='PCPGIFT'"
                                       :giftInfo="booking?.personalizedStateroomInfo"
                                       :shipCode="booking.shipCode"
                                       :sailDate="booking.sailDate"
                                       :guestNumber="booking.bookingGuests.length"
                                       @open="showCustomThemePopup"
                                       is-on-page-popup
                                       pageName="Pay"></PcpGiftView>
                        </div>
                        <div class="order-line"></div>
                    </div>

                </div>

            </div>
            <div class="hsbcBanner" v-if="false">
            <Swiper
                ref="bannerSwiper"
                :options="swiperOptions"
                class="swiper-container swiper-topics topics"
                @click-slide="onShowPopupsImg"
            >
              <SwiperSlide
                  v-for="(item, i) in hsbcBanners"
                  :key="i"
                  class="swiper-slide promoBannerLink external"
              >
                <div>
                  <img :src="item.image" alt=""/>
                </div>
              </SwiperSlide>
              <div
                  ref="swiper-pagination"
                  class="swiper-pagination"
                  v-if="hsbcBanners.length > 1"
                  slot="pagination"
              ></div>
            </Swiper>
            </div>
            <div class="common-box payMethod scroll-container">
                <div class="payMethod-cell" :class="{ active: paymentType == 'MOBILEALIPAY'}" @click="paymentType='MOBILEALIPAY'">
                    <div class="payMethod-cell-m">
                        <img src="https://resource.rcclchina.com.cn/RcclHP/alipay.png">
                        支付宝支付
                    </div>
                    <div class="payMethod-cell-hook">
                        <img src="https://resource.rcclchina.com.cn/RcclHP/BOOKING/icon10.png">
                    </div>
                </div>
                <div class="payMethod-cell" :class="{ active: paymentType == 'MOBILEWECHATPAY'}" @click="paymentType='MOBILEWECHATPAY'">
                    <div class="payMethod-cell-m">
                        <img src="https://resource.rcclchina.com.cn/content/weixinimg3.png">
                        微信支付
                    </div>
                    <div class="payMethod-cell-hook">
                        <img src="https://resource.rcclchina.com.cn/RcclHP/BOOKING/icon10.png">
                    </div>
                </div>

                <div v-if="paymentMethodType!==null && paymentMethodType===1" class="payMethod-cell" :class="{ active: paymentType == 'UNIONPAY'}" @click="paymentType='UNIONPAY'">
                    <div class="payMethod-cell-m">
                        <img src="https://resource.rcclchina.com.cn/cruiseDetail/unionPay.png">
                        银联支付
                    </div>
                    <div class="payMethod-cell-hook">
                        <img src="https://resource.rcclchina.com.cn/RcclHP/BOOKING/icon10.png">
                    </div>
                </div>

                <div v-if="paymentMethodType!==null && paymentMethodType===1" class="bank-cell">
                    <div class="bank-cell-m" @click="showBankPopup">
                        <img src="https://resource.rcclchina.com.cn/paySuccess/bankIcon.png">
                        <div class="bank-text">
                            银行转账/汇款<span style="color: red;"> (不推荐)</span><br>至皇家加勒比游轮船务(中国)有限公司<br>官方银行账户：<span class="tip"
                                id="bankTip" >摩根大通银行账户</span>
                        </div>
                    </div>
                    <div class="bank-cell-tips">
                        如果您银联支付遇到困难，也可以使用银行汇款方式付款（请在转账时备注好您的订单号、姓名、手机号）。若选择汇款，请务必在完成付款后致电400-820-7293与客服人员确认。转账/汇款无备注或未及时与客服确认，会导致订单因无法及时入账而自动取消。
                    </div>
                </div>

                <div class="payCaption">

                    <p class="payCaption-txt2">
                        发票说明：
                    </p>
                    <p class="payCaption-txt1">
                        1）官网预订仅可开具增值税普通发票，无法开具增值税专用发票。发票内容为“生产生活服务·船票款”，不得进行修改。建议发票在航次结束后3个月内申请开具。
                    </p>
                    <p class="payCaption-txt1">
                        2）官方线下渠道使用美金支付的船票款只能开具形式发票。其它船上消费因已属境外消费，需要找船上开具账单。
                    </p>
                    <p class="payCaption-txt1">
                        3）个人付款可开具个人抬头发票，公司转款可开具公司抬头发票（请务必通过公司账户银行转账）。个人付款如需开具公司抬头发票，需提供公司名称、税号等必要的开票信息。
                    </p>
                    <p class="payCaption-txt1">
                        4) 如因订单内容变更总金额发生变动、需要重新开发票的，预订人需先退回原发票后方可开具新的发票。
                    </p>
                </div>
                

            </div>
        </div>
        <div class="toPay-main" :class="{'is-integral': totalIntegral && totalValuation}">
            <div v-if="totalIntegral && totalValuation" class="toPay-integral">
              <img :src="`${imgUrl}/icons/icon-integral-yellow.png`"/>
              下船后预计送<span>{{totalIntegral || '--'}}</span>积分
              <!-- 下船后预计送<span>{{totalIntegral || '--'}}</span>积分，可至积分商城兑换价值约<span>{{totalValuation || '--'}}</span>元电话卡 -->
            </div>
            <div class="toPay-m">
              <div class="toPay-m-l">
                  <div class="inner-top" :class="{'is-deposit': !isDeposit}">
                    <div class="toPay-m-num"><span id="toPayNum">{{paymentBookingCount}}</span>张订单</div>
                    <div class="toPay-m-txt">应付总计:￥</div>
                    <div class="toPay-m-price">{{paymentAmount}}</div>
                  </div>
                  <div v-if="isDeposit" class="inner-bottom">*最晚于开航45天前支付尾款，逾期将取消</div>
              </div>
              <div class="toPay-m-r" @click="submitPayment()">立即支付</div>
            </div>
        </div>

        <BankPopup
            :onGoBack="closeBankPopup"
            :isShow="isShowBankPopup"
            :bankTransferInfo="bankTransferInfo"
        />

        <DownPayPopup
            :onGoBack="closeDownpayPopup"
            :isShow="isShowDownpayPopup"
            :isNrp="targetBooking.isnrp"
        />

        <ConnectRoomPopup
            :onGoBack="closeConnectRoomPopup"
            :isShow="isShowConnectRoomPopup"
        />

        <QiaohuPopup
            :shipCode="tagetQiaohu.shipCode"
            :sailDate="tagetQiaohu.sailDate"
            :onGoBack="closeQiaohuPopup"
            :isShow="isShowQiaohuPopup"
        />

        <StarrySkyPopup
            :shipCode="shipCode"
            :sailDate="sailDate"
            :onGoBack="closeStarrySkyPopup"
            :isShow="isShowStarrySkyPopup"
        />

        <CustomThemePopup
            :onGoBack="closeCustomThemePopup"
            :isShow="isShowCustomThemePopup"
            :themeInfo="personalizedStateroomInfo"
        />

      <popups-img v-show="isShowPopupsImg"
                    :imgUrl="popupsImgUrl"
                    @closePopups="onClosePopups">
        </popups-img>
    </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import wechatHelper from '@/utilities/wechatHelper'
import { numberWithCommas } from '@/utilities/tools'
import { Swiper, SwiperSlide, directive} from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import PopupsImg from "@/components/Cruise/popupsImg.vue";
import StarrySkyPopup from "@/components/Cruise/StarrySkyPopup.vue";
import PcpGiftView from "@/components/PCP/PcpGiftView.vue";
const BankPopup = () => import ('@/components/Booking/BankPopup')
const DownPayPopup = () => import ('@/components/Booking/DownPayPopup')
const QiaohuPopup = () => import('@/components/Cruise/QiaohuPopup')
const ConnectRoomPopup = () => import('@/components/Cruise/ConnectRoomPopup')
const CustomThemePopup =()=> import("@/components/Cruise/CustomThemePopup.vue")
export default {
    name: "Pay",
    components: {
      PcpGiftView,
      StarrySkyPopup,
      PopupsImg,
        Swiper,
        SwiperSlide,
        BankPopup,
        DownPayPopup,
        QiaohuPopup,
        ConnectRoomPopup,
        CustomThemePopup
    },
    directives: {
      swiper: directive,
    },
    data() {
        return {
            imgUrl: process.env.VUE_APP_IMG_URL,
            logoImgUrl: process.env.VUE_APP_LOGO_IMG_URL,
            paymentType: "MOBILEALIPAY",
            isHideNoPayBooking: false,
            isShowBankPopup: false,
            isShowDownpayPopup: false,
            isShowConnectRoomPopup: false,
            isShowQiaohuPopup: false,
            isShowStarrySkyPopup: false,
            paymentBookings: {},
            targetBooking: {},
            tagetQiaohu: {
                shipCode: '',
                sailDate: ''
            },
            isDeposit: false,
            totalIntegral: null,
            totalValuation: null,
            swiperOptions: {
              pagination: {
                el: ".swiper-pagination",
              },
              loop: false,
              autoplay: {
                delay: 5000,
              },
            },
            hsbcBanners:null,
            popupsImgUrl:'',
            isShowPopupsImg:false,
            bookingViewModels:null,
            bookingState:false,  //订单状态
            paymentMethodType: null,
            bankTransferInfo: {
                popupBoxType:1,// 1显示默认弹框 2.显示临近航线弹框（显示ShowFinalPaymentTime字段）
                showFinalPaymentTime:'' 
            },
            isShowCustomThemePopup: false,
            personalizedStateroomInfo: null
        }
    },
    beforeMount() {
        const self = this
        this.$store.commit('SET_PAGE_TITLE', '支付订单')
        self.initPage()
        window.onpopstate = () => {
          if (self.isShowBankPopup) {
            self.closeBankPopup()
          }
          if (self.isShowDownpayPopup) {
            self.closeDownpayPopup()
          }
          if (self.isShowConnectRoomPopup) {
            self.closeConnectRoomPopup()
          }
          if (self.isShowQiaohuPopup) {
            self.closeQiaohuPopup()
          }
        }
    },
    mounted () {
        // 隐藏头尾
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: true, isHideFooter: true})
      this.getCruiseBanner()
    },
    beforeDestroy () {
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: false, isHideFooter: false})
        window.onpopstate = () => {}
    },
    methods: {
        reload() {
          location.reload()
        },
        async initPage () {
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken == '') {
                this.$router.push({ name: 'Login', query:{
                    returnUrl: location.href
                }})
                return
            }
            const query = this.$router.currentRoute.query
            this.$loading.show()
            const { data } = await api.booking.paymentPage({
                // 使用加密字段encOrderId
                encOrderId: query.orderId,
                // 使用加密字段encBookingId
                encBookingId: query.bookingId,
                userName: userToken
            })
            this.$loading.hide()

            if (data && data.bookingIntegrals && data.bookingIntegrals.length > 0) {
              let totalIntegral = 0;
              let totalValuation = 0;
              data.bookingIntegrals && data.bookingIntegrals.forEach(row => {
                totalIntegral += row.integral;
                totalValuation += row.valuation;
              })
              this.totalIntegral = numberWithCommas(totalIntegral);
              this.totalValuation = totalValuation.toFixed('0');
            }
            if (data) {
                this.paymentMethodType = data.paymentMethodType;
                this.bankTransferInfo.popupBoxType = data.popupBoxType;
                this.bankTransferInfo.showFinalPaymentTime = data.showFinalPaymentTime;
                this.paymentBookings = this.initBookings(data)
                this.setIsDeposit();
            } else {
                return this.$router.push({
                    name: "BookingList"
                })
            }


            if (data && data.bookingViewModels && data.bookingViewModels.length > 0) {
              this.bookingViewModels = data.bookingViewModels
            } else {
              return this.$router.push({
                name: "BookingListPage"
              })
            }
            try {
                if(window && window.gio){
                    const query = this.$route.query
                    if(query && query.orderId && query.orderId.length > 0){
                        const orderId = query.orderId
                        const bookingsCount = this.bookings.length + this.noPayBookings.filter(r=>r.isSelected).length
                        window.gio("page.set", "OrderGenerationID", orderId);
                        window.gio("page.set", "CruiseLine", this.shipCode + this.sailDate);
                        window.gio('page.set', 'ShipCode', this.shipCode);
                        window.gio('page.set', 'SailDate', this.sailDate);
                        window.gio('page.set', 'CruiseType', 'CruiseOnly');
                        window.gio("track", "order_id_var", orderId);
                        window.gio('track', 'BookingCount', { 'BookingCount': bookingsCount});
                        window.gio('track','SubmitOF',{'shipCode':this.shipCode,'sailDate':this.sailDate});
                    }
                }
            } catch (e) {
                console.error(e)
            }

        },
        // 预处理接口返回结果，新增isSelect字段，将booking pay对象放到booking里面
        initBookings (data) {
            if (data.apiBookings && data.apiBookings.length > 0) {
                data.apiBookings.forEach((booking) => {
                    booking.isSelected = true
                    if (data.bookingViewModels) {
                        const bookingPay = data.bookingViewModels.find(r=>r.bookingRecordId == booking.id)
                        booking.bookingPay = bookingPay
                    }
                })
            }

            if (data.noPayApiBookings && data.noPayApiBookings.length > 0) {
                data.noPayApiBookings.forEach((booking) => {
                    booking.isSelected = false
                    if (data.bookingViewModels) {
                        const bookingPay = data.bookingViewModels.find(r=>r.bookingRecordId == booking.id)
                        booking.bookingPay = bookingPay
                    }
                })
            }
            return data
        },
        goBack () {
            this.$router.go(-1)
        },
        setBookingDownpay(e, booking) {
            if (booking.bookingPay && booking.bookingPay.isDownPayCruise) {
                booking.bookingPay.allowDownPayment = !booking.bookingPay.allowDownPayment
            }
            this.setIsDeposit()
        },
        setIsDeposit () {
          let allowDownPaymentNum = 0;
          this.bookings && this.bookings.forEach((row)=> {
            if(row.bookingPay.allowDownPayment) {
              allowDownPaymentNum += 1;
            }
          })
          this.isDeposit = allowDownPaymentNum > 0;
        },
        getStateroom (booking) {
            const stateroom = booking.stateroomPartView || {}
            return stateroom
        },
        getStateroomName (booking) {
            const stateroom = booking.stateroomPartView || {}
            const name = stateroom.cnName
            let code = stateroom.stateroomCategoryCode
            if (code.indexOf('_') >= 0) {
                code = code.split('_')[0]
            }
            let guestNumberText = ''
            switch (this.getGuests(booking).length) {
                case 1: guestNumberText = '单人房'; break;
                case 2: guestNumberText = '双人房'; break;
                case 3: guestNumberText = '三人房'; break;
                case 4: guestNumberText = '四人房'; break;
                default: break;
            }
            return `${name}_${code}（${guestNumberText}）`
        },
        // 阳台面积，包含遮挡率
        getBalconyArea (booking) {
            const stateroom = this.getStateroom(booking)
            if (!stateroom.balconyAreaInfo || stateroom.balconyAreaInfo == '' || stateroom.balconyAreaInfo == '无') {
                return '无阳台'
            }
            if (stateroom.stateroomShelter && stateroom.stateroomShelter.length > 0) {
                return "(" + stateroom.stateroomShelter + "视线遮挡) " + stateroom.balconyAreaInfo
            }
            return stateroom.balconyAreaInfo
        },
        getStateroomImage (booking) {
            const stateroom = booking.stateroomPartView || {}
            return stateroom.desImage
        },
        getGuests (booking) {
            return booking.bookingGuests || []
        },
        getGuestName (booking) {
            let guestName = []
            const guests = this.getGuests(booking)
            guests.forEach((guest) => {
                let name = guest.chineseLastName + guest.chineseFirstName
                if (!name || name.length == 0) {
                    name = `${guest.pinYinLastName} ${guest.pinYinFirstName}`
                }
                guestName.push(name)
            })
            return guestName.join('，')
        },
        getGuestsNameStr(booking) {
          let guestsNameStr = '';
          booking.bookingGuests.forEach((guest)=> {
            if(guest.chineseFirstName !== "TBA" && guest.chineseLastName !== "TBA") {
              let title = (guest.chineseLastName || '')+(guest.chineseFirstName || '')
              if (title == '') {
                title = `${guest.pinYinLastName} ${guest.pinYinFirstName}`
              }
              guestsNameStr += title + '、';
            }
          })
          return guestsNameStr.substr(0,guestsNameStr.length-1);
        },
        getBookingPay(booking) {
            return booking.bookingPay
        },
        getBookingIntegral (booking) {
            if (!this.paymentBookings.bookingIntegrals || this.paymentBookings.bookingIntegrals.length == 0) {
                return ""
            }
            const bookingIntegral = this.paymentBookings.bookingIntegrals.find(r=>r.bookingId == booking.bookingId)
            if (!bookingIntegral) {
                return ""
            }
            return numberWithCommas(bookingIntegral.integral)
        },
        getBookingIntegralValue (booking) {
            if (!this.paymentBookings.bookingIntegrals || this.paymentBookings.bookingIntegrals.length == 0) {
                return ""
            }
            const bookingIntegral = this.paymentBookings.bookingIntegrals.find(r=>r.bookingId == booking.bookingId)
            if (!bookingIntegral) {
                return ""
            }
            return bookingIntegral.valuation.toFixed('0')
        },
        closeBankPopup () {
            this.isShowBankPopup = false
        },
        showBankPopup () {
            this.isShowBankPopup = true
            this.showPopup()
        },
        showDownpayPopup (booking) {
            this.isShowDownpayPopup = true
            this.targetBooking = booking
            this.showPopup()
        },
        closeDownpayPopup () {
            this.isShowDownpayPopup = false
        },
        showConnectRoomPopup () {
            this.isShowConnectRoomPopup = true
            this.showPopup()
        },
        closeConnectRoomPopup () {
            this.isShowConnectRoomPopup = false
        },
        showQiaohuPopup (shipCode, sailDate) {
            this.tagetQiaohu = {
                shipCode,
                sailDate
            }
            this.isShowQiaohuPopup = true
            this.showPopup()
        },
        closeQiaohuPopup () {
            this.isShowQiaohuPopup = false
        },
        closeStarrySkyPopup () {
          this.isShowStarrySkyPopup = false;
        },
        showCustomThemePopup(val) {
          this.personalizedStateroomInfo = val;
          this.isShowCustomThemePopup = true;
        },
        closeCustomThemePopup() {
          this.isShowCustomThemePopup = false;
        },
        showPopup() {
            history.pushState({ page: 'pay' }, null);
        },
        showBookingIntegralTips() {
            this.$alert.show('积分将于下船后约10天发放至本账户，可在积分商城【积分明细】查看。', {
                button: '我知道了'
            })
        },
        // 去支付
        async submitPayment () {
            const bookingPayments = this.getSubmitPaymentBooking()
            await this.checkBookingStates(bookingPayments)  //获取订单状态
            if(!this.bookingState) return
            if (bookingPayments.length == 0) return
            let paymentType = this.paymentType + ''
            if (wechatHelper.isWeixinBrowser() && paymentType == 'MOBILEWECHATPAY') {
                paymentType = 'WECHATPAY'
            }

            location.href = `/Rccl.Booking/Booking/PayByMethod?`
            +`bookingId=${bookingPayments.map(r=>r.encBookingId).join(',')}`
            +`&paymentType=${bookingPayments.map(r=>r.downPayment).join(',')}`
            + `&payMethod=${paymentType}&returnUrl=${encodeURIComponent(location.href)}`;


            // const request = {
            //     bookingId: bookingPayments.map(r=>r.bookingId).join(','),
            //     paymentType: bookingPayments.map(r=>r.downPayment).join(','),
            //     payMethod: paymentType,
            //     wechatOpenId: this.$store.state.user.wechatOpenId
            // }
            // this.$loading.show()
            // const { success, data, errMsg } = await api.booking.payByMethodHP(request)
            // this.$loading.hide()
            // if (!success) {
            //     this.$alert.show(errMsg)
            // }
            // if (data && data.checkoutShape && data.checkoutShape.length > 0) {
            //     this.$router.push({
            //         name: "PayByMethod",
            //         params: {
            //             paymentContent: data,
            //             paymentType: paymentType,
            //             orderId: this.orderId,
            //             requestId: this.requestId
            //         },
            //         query: {
            //             returnUrl: encodeURIComponent(location.href)
            //         }
            //     })
            // }
        },
        // 获取订单状态
        async checkBookingStates(bookingPayments) {
          const stateParam = {
            encBookingRecordId:''
          }
          for (const r of bookingPayments) {
            if (r.encBookingRecordId) {
              stateParam.encBookingRecordId = r.encBookingRecordId;
              this.$loading.show();
              const res = await api.booking.getPayBookingState(stateParam);
              this.$loading.hide()
              if (!res.data.isBookingValid) {
                this.bookingState = false;
                this.$alert.show(res.errMsg);
                return
              }
              this.bookingState = true; // 订单状态
            }
          }
        },
        getSubmitPaymentBooking () {
            let bookingPayments = []
            this.bookings.forEach((booking) => {
                if (booking.bookingPay) {
                    let bookingPayment = {
                        // 这里使用加密字段
                        encBookingId: booking.encBookingId,
                        downPayment: '',
                        // 这里需要使用加密字段encBookingRecordId
                        encBookingRecordId: booking.encBookingRecordId
                    }
                    if (booking.bookingPay.allowDownPayment && booking.bookingPay.isDownPayCruise) {
                        bookingPayment.downPayment = 'DOWNPAYMENT_'+booking.bookingId
                    } else {
                        bookingPayment.downPayment = 'NULL'
                    }
                    bookingPayments.push(bookingPayment)
                }
            })
            this.noPayBookings.forEach((booking) => {
                if (booking.bookingPay && booking.isSelected) {
                    let bookingPayment = {
                        // 这里使用加密字段
                        encBookingId: booking.encBookingId,
                        downPayment: '',
                        // 这里需要使用加密字段encBookingRecordId
                        encBookingRecordId: booking.encBookingRecordId
                    }
                    if (booking.bookingPay.allowDownPayment && booking.bookingPay.isDownPayCruise) {
                        bookingPayment.downPayment = 'DOWNPAYMENT_'+booking.bookingId
                    } else {
                        bookingPayment.downPayment = 'NULL'
                    }
                    bookingPayments.push(bookingPayment)
                }
            })
            return bookingPayments
        },
        goToDetail (encBookingId) {
            this.$router.push({
                name: "BookingDetail",
                query: {
                    bookingId:encBookingId
                }
            })
        },
        getUnFilledGuest (booking) {
          let unFilledGuestNum = 0;
          booking.bookingGuestExts && booking.bookingGuestExts.forEach((row)=> {
            if(row.unFilledGuest) {
              unFilledGuestNum += 1;
            }
          })
          return unFilledGuestNum > 0;
        },
        async getCruiseBanner() {
          const requestData = {
            businessType:2
          }
          const {success, data, errMsg} = await api.cruise.getCruiseBannerApi(requestData);
          if (success) {
            this.hsbcBanners = data
            console.log(this.hsbcBanners)
          } else {
            this.$alert.show(errMsg);
          }
        },
        onShowPopupsImg(idx){
            console.log('点击',idx)
            this.popupsImgUrl = ''
            this.popupsImgUrl = this.hsbcBanners[idx].popupImageUrl
            this.isShowPopupsImg = true
        },
        onClosePopups(){
          this.isShowPopupsImg = false
        }
    },
    computed: {
        isRow(){
            return this.bookings[0] && this.bookings[0].isRow
        },
        bookings () {
            console.log(this.paymentBookings.apiBookings,'this.paymentBookings.apiBookings')
            return this.paymentBookings.apiBookings || []
        },
        // 显示倒计时状态
        showCountDown () { 
            let bool = true
            if(this.bookings.length == 0) return false
            this.bookings.forEach((booking) => {
                if (this.getBookingPay(booking) && this.getBookingPay(booking).paymentType == 'DIFF') {
                    bool = false
                }else{
                    bool = true
                }
            })
            return bool
        },
        finalPaymentTime () {
            if (this.bookings.length == 0) {
                return ""
            }
            const createDate = moment(this.bookings[0].createdDate)
            return createDate.add(1, 'days').format('YYYY-MM-DD HH:mm:ss')
        },
        normalBookings () {
            return this.bookings.filter(r=>!r.connectId || r.connectId.length == 0)
        },
        connectBookings () {
            const connectBookings = this.bookings.filter(r=>r.connectId && r.connectId.length > 0)
            let bookings = []
            connectBookings.forEach((booking) => {
                let connectBooking = bookings.find(r=>r.connectId == booking.connectId)
                if (connectBooking) {
                    connectBooking.bookings.push(booking)
                } else {
                    connectBooking = {
                        connectId: booking.connectId,
                        bookings: [booking]
                    }
                    bookings.push(connectBooking)
                }
            })
            return bookings
        },
        noPayBookings () {
            return this.paymentBookings.noPayApiBookings || []
        },
        contact () {
            const contacts = this.paymentBookings.bookingContacts || []
            if (contacts.length > 0) {
                return contacts[0]
            }
            return {}
        },
        contactName () {
            let name = this.contact.chineseLastName + this.contact.chineseFirstName
            if (!name || name.length == 0) {
                name = `${this.contact.pinYinLastName} ${this.contact.pinYinFirstName}`
            }
            return name
        },
        paymentBookingCount () {
            return this.bookings.length + this.noPayBookings.filter(r=>r.isSelected).length
        },
        paymentAmount () {
            let amount = 0
            this.bookings.forEach((booking) => {
                if (booking.bookingPay) {
                    if (booking.bookingPay.allowDownPayment && booking.bookingPay.isDownPayCruise) {
                        amount += booking.bookingPay.downPayAmount
                    } else {
                        amount += booking.bookingPay.amount
                    }
                }
            })

            this.noPayBookings.forEach((booking) => {
                if (booking.isSelected && booking.bookingPay) {
                    if (booking.bookingPay.allowDownPayment && booking.bookingPay.isDownPayCruise) {
                        amount += booking.bookingPay.downPayAmount
                    } else {
                        amount += booking.bookingPay.amount
                    }
                }
            })

            return amount
        },
        shipCode () {
            if (this.bookings.length == 0) {
                return ""
            }
            return this.bookings[0].shipCode
        },
        sailDate () {
            if (this.bookings.length == 0) {
                return ""
            }
            return this.bookings[0].sailDate
        }
    }

}
</script>

<style lang="less" scoped>
.page-content img {
    max-width: 100%;
    z-index: 99;
}
.stateroomDetail-t {
    position: fixed;
    width: 100%;
    text-align: center;
    height: 50px;
    line-height: 50px;
    background-color: #fff;
    top: 0;
    left: 0;
    z-index: 5001;
    .stateroomDetail-returnButton {
        width: 30px;
        position: absolute;
        top: 4px;
        left: 20px;
        text-align: left;
        img {
            width: 33%;
        }
    }
    .stateroomDetail-t-title {
        
        font-size: 14px;
        color: #333333;
        letter-spacing: 1px;
        margin: 0;
    }
}

.page-content-ptb {
    background: #F6F7F8;
    padding-bottom: 49px;
    &.is-integral {
      padding-bottom: 73px;
    }
}

.count-down {
    margin: 0 15px;
    padding: 10px 0 11px;
    font-size: 10px;
    line-height: 14px;
    color: #999;
    text-align: center;
    span {
        color: rgba(255, 80, 85, 1.0);
    }
}
.order {
    width: 355px;
    margin: 0 auto 10px;
    padding: 0 10px;
    border-radius: 5px;
    background-color: #fff;
    border: 1px solid #FEBC10;
    border-top: 5px solid #FEBC10;
    -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    position: relative;
    .route-info {
        padding: 14px 0 0;
        .route-name {
            padding-bottom: 5px;
            padding-right: 3.8rem;
            font-size: 14px;
            line-height: 20px;
            color: #333;
            font-weight: bold;
        }
        .route-ship {
            padding-bottom: 7px;
            padding-right: 3.8rem;
            font-size: 12px;
            line-height: 16px;
            color: #666;
        }
        .route-row {
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            padding-bottom: 6px;
            .route-row-txt {
                -webkit-box-flex: 1;
                -webkit-flex: 1;
                -moz-box-flex: 1;
                -ms-flex: 1;
                flex: 1;
                font-size: 12px;
                line-height: 12px;
                color: #151515;
                display: flex;
                align-items: center;
                .modify-box {
                    display: -webkit-box;
                    display: -webkit-flex;
                    display: -moz-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-align: center;
                    -webkit-align-items: center;
                    -moz-box-align: center;
                    -ms-flex-align: center;
                    align-items: center;
                    margin-left: 8px;
                    font-size: 12px;
                    line-height: 16px;
                    color: #4A90E2;
                    font-weight: bold;
                    img {
                        display: block;
                        width: 13px;
                        margin-right: 5px;
                    }
                }
            }
            .route-row-title {
                -webkit-box-flex: 0;
                -webkit-flex: none;
                -moz-box-flex: 0;
                -ms-flex: none;
                flex: none;
                width: 48px;
                font-size: 12px;
                line-height: 16px;
                color: #666;
            }
        }

        .route-row2 {
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-flex-wrap: wrap;
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;
            margin-left: 60px;
            font-size: 12px;
            line-height: 12px;
            color: #666;
            .route-row2-txt {
                margin-right: 10px;
                padding-right: 10px;
                border-right: 1px solid #979797;
                word-break: break-all;
            }
            .route-row2-txt {
                margin-right: 10px;
                padding-right: 10px;
                border-right: 1px solid #979797;
                word-break: break-all;
            }
            .route-row2-txt:last-child {
                margin-right: 0;
                padding-right: 0;
                border-right: none;
            }
        }


        .order-line {
            margin-top: 16px;
        }
    }

    .cabinItem {
        position: relative;
        // margin-top: 12px;
        .cabinItem-m {
            display: inline-block;
            width: 310px;
            vertical-align: top;
            padding-bottom: 7px;
            .cabinItem-title {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -moz-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                padding-bottom: 12px;
                .cabinItem-title-num {
                    -webkit-box-flex: 1;
                    -webkit-flex: 1;
                    -moz-box-flex: 1;
                    -ms-flex: 1;
                    flex: 1;
                    display: -webkit-box;
                    display: -webkit-flex;
                    display: -moz-box;
                    display: -ms-flexbox;
                    display: flex;
                    font-size: 14px;
                    line-height: 18px;
                    font-weight: bold;
                    .cabinItem-title-num-txt1 {
                        margin-right: 3px;
                        color: #4A90E2;
                    }
                    .cabinItem-title-num-txt2 {
                        margin-right: 10px;
                        color: #151515;
                    }
                }
            }
            .cabinItem-box {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                margin-bottom: 10px;
                .cabinItem-img {
                    -webkit-box-flex: 0;
                    -webkit-flex: none;
                    -moz-box-flex: 0;
                    -ms-flex: none;
                    flex: none;
                    width: 100px;
                    margin-right: 12px;
                }
                .cabinItem-info {
                    -webkit-box-flex: 1;
                    -webkit-flex: 1;
                    -moz-box-flex: 1;
                    -ms-flex: 1;
                    flex: 1;
                    .cabinItem-info-title {
                        display: -webkit-box;
                        display: -webkit-flex;
                        display: -moz-box;
                        display: -ms-flexbox;
                        display: flex;
                        font-weight: bold;
                        .cabinItem-info-title-l {
                            -webkit-box-flex: 1;
                            -webkit-flex: 1;
                            -moz-box-flex: 1;
                            -ms-flex: 1;
                            flex: 1;
                            padding-right: 2px;
                            font-size: 12px;
                            line-height: 16px;
                            color: #333;
                        }

                    }
                    .cabinItem-info-brief {
                        margin-top: 2px;
                        font-size: 12px;
                        line-height: 16px;
                        color: #666;
                    }
                    .cabinItem-info-num {
                        margin-top: 2px;
                        font-size: 12px;
                        line-height: 16px;
                        color: #666;
                    }
                    .cabinItem-info-name {
                        margin-top: 2px;
                        font-size: 12px;
                        line-height: 16px;
                        color: #666;
                    }
                    .Connectroom-info-num {
                        padding-bottom: 3px;
                    }
                    .CONNECT_CSS {
                        // width: 93px;
                        height: 18px;
                        margin-top: 3px;
                    }
                }
            }
            .cabinItem-price {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-pack: end;
                -webkit-justify-content: flex-end;
                -moz-box-pack: end;
                -ms-flex-pack: end;
                justify-content: flex-start;
                -webkit-box-align: baseline;
                -webkit-align-items: baseline;
                -moz-box-align: baseline;
                -ms-flex-align: baseline;
                align-items: baseline;
                font-size: 15px;
                line-height: 20px;
                color: #FF5055;
                font-weight: bold;
                margin-top: 10px;
                span {
                    display: block;
                    margin-right: 3px;
                    font-size: 12px;
                }
            }
            .cabinItem-un-filled {
              overflow: hidden;
              font-size: 12px;
              color: #4A90E2;
              & .icon {
                height: 12px;
                float: left;
                margin-right: 4px;
                margin-top: 2px;
              }
              & .text {
                line-height: 18px;
                overflow: hidden;
                letter-spacing: -1px;
              }
            }
            .cabinItem-deposit {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -moz-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                padding-top: 7px;
                padding-bottom: 5px;
                position: relative;
                z-index: 100;
                .cabinItem-deposit-l {
                    -webkit-box-flex: 1;
                    -webkit-flex: 1;
                    -moz-box-flex: 1;
                    -ms-flex: 1;
                    flex: 1;
                    padding-right: 10px;
                    font-size: 12px;
                    line-height: 16px;
                    color: #333;
                    img {
                        margin-left: 1px;
                        width: 14px;
                        vertical-align: -2px;
                    }
                }
                .cabinItem-deposit-r {
                    -webkit-box-flex: 0;
                    -webkit-flex: none;
                    -moz-box-flex: 0;
                    -ms-flex: none;
                    flex: none;
                }
            }

            .cabinItem-jifen {
                font-size: 12px;
                color: #333;
                text-align: right;
                position: relative;
                z-index: 100;
                span {
                    color: #4A90E2;
                }
                img {
                    margin-left: 1px;
                    width: 14px;
                    vertical-align: -2px;
                }
            }

            .order-line {
                position: absolute;
                left: 0;
                bottom: 0;
            }
        }
        .order-line {
          margin-top: 16px;
        }
    }

    .cabinItem-wrap .cabinItem-m  {
        width: 333px;
    }

    .cabinItem div.c_cabinItem-wrap {
        background: #FFF7CD;
        padding: 0 10px;
        margin-left: -10px;
        margin-right: -10px;
        width: 353px;
        padding-top: 12px;
    }

    .c_cabinItem-wrap.c_first_room {
        border-top: 2px solid #F8DE57;
    }

    .c_wrap {
        margin-bottom: 10px;
        .c_img_conpay {
            position: absolute;
            bottom: -14px;
        }
    }

    .meargeCabin .cabinItem:first-child {
        margin-top: 0px;
    }


    .mergeTip-order-line {
        margin-bottom: 17px;
    }
    .mergeTip {
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding-bottom: 15px;
        .mergeTip-txt {
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            -moz-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            font-size: 14px;
            line-height: 20px;
            color: #4A90E2;
        }
    }
    .mergeTip-arrow {
        display: block;
        width: 13px;
        -webkit-transform: rotate(-90deg);
        -moz-transform: rotate(-90deg);
        -ms-transform: rotate(-90deg);
        -o-transform: rotate(-90deg);
        transform: rotate(-90deg);
    }
    .mergeTip.active .mergeTip-arrow {
        -webkit-transform: rotate(0);
        -moz-transform: rotate(0);
        -ms-transform: rotate(0);
        -o-transform: rotate(0);
        transform: rotate(0);
    }

    .meargeCabin {
        .cabinItem-icon {
            margin-top: 1px;
            margin-right: 8px;
            img {
                display: none;
                width: 12px;
                position: relative;
                top: 2px;
            }
        }

        .cabinItem.active .cabinItem-icon {
            background-color: #4A90E2;
             img {
                display: block;
            }
        }
    }

    .cabinItem-icon {
        display: inline-block;
        vertical-align: top;
        align-items: center;
        width: 15px;
        height: 15px;
        border: 1px solid #4A90E2;
        border-radius: 100%;
    }

    .deposit .label-switch, .cabinItem-deposit-r .label-switch {
        width: 31px;
        height: 16px;
        border-radius: 10px;
    }
    .deposit .label-switch .checkbox, .cabinItem-deposit-r .label-switch .checkbox {
        width: 31px;
        height: 16px;
        border-radius: 10px;
    }
    .deposit .label-switch .checkbox:before, .cabinItem-deposit-r .label-switch .checkbox:before {
        left: 0px;
        top: 0px;
        width: 31px;
        height: 16px;
        border-radius: 10px;
        background-color: #ccc;
    }
    .deposit .label-switch .checkbox:after, .cabinItem-deposit-r .label-switch .checkbox:after {
        left: 0px;
        top: 0px;
        width: 16px;
        height: 16px;
        border-radius: 100%;
        -webkit-box-shadow: 0 2px 5px 0 rgba(0,0,0,0.30);
        box-shadow: 0 2px 5px 0 rgba(0,0,0,0.30);
    }

    .order-line {
        // width: 100%;
        // height: 1px;
        // background: url(https://resource.rcclchina.com.cn/bookingPay/line.png) repeat-x;
        // -webkit-background-size: auto 100%;
        // -o-background-size: auto 100%;
        // background-size: auto 100%;
    }
}

.common-box {
    margin-bottom: 10px;
    padding: 0 20px;
    background-color: #fff;
    .payMethod-cell {
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        height: 58px;
        border-bottom: 1px solid #E5E5E5;
        .payMethod-cell-m {
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            -moz-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            font-size: 12px;
            line-height: 16px;
            color: #333;
            img {
                display: block;
                width: 27px;
                margin-right: 12px;
            }
        }
        .payMethod-cell-hook {
            -webkit-box-flex: 0;
            -webkit-flex: none;
            -moz-box-flex: 0;
            -ms-flex: none;
            flex: none;
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: center;
            -webkit-justify-content: center;
            -moz-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            width: 15px;
            height: 15px;
            border: 1px solid #4A90E2;
            border-radius: 100%;
            img {
                display: none;
                width: 12px;
            }
        }
    }

    .payMethod-cell.active .payMethod-cell-hook {
        background-color: #4A90E2;
        img {
            display: block;
        }
    }

    .bank-cell {
        padding-top: 20px;
        border-bottom: 1px solid #E5E5E5;
        .bank-cell-m {
            img {
                display: inline-block;
                width: 27px;
                margin-right: 8px;
                vertical-align: top;
            }
            .bank-text {
                display: inline-block;
                vertical-align: top;
                width: 238px;
                font-size: 12px;
                color: #333;
                line-height: 19px;
            }
            #bankTip {
                color: #0073bb;
            }
        }
        .bank-cell-tips {
            font-size: 12px;
            color: #666;
            margin-top: 10px;
            line-height: 20px;
            padding-bottom: 10px;
        }
    }

    .payCaption {
        margin-bottom: 0;
        padding-bottom: 20px;
        .payCaption-txt1 {
            margin: 0;
            font-size: 12px;
            line-height: 20px;
            color: #666;
        }
        .payCaption-txt2 {
            margin: 0;
            padding-top: 10px;
            font-size: 12px;
            line-height: 20px;
            color: #666;
            font-weight: bold;
        }
    }
}

.toPay-main {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    width: 100%;
    height: 49px;
    &.is-integral {
      height: 73px;
    }
    .toPay-integral {
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      letter-spacing: -1px;
      text-align: center;
      background-color: #F6F7F9;
      & > img {
        height: 14px;
        margin-bottom: -2px;
      }
      & > span {
        padding: 0 5px;
        color: #348cc8;
      }
    }
    .toPay-m {
      height: 49px;
      display: -webkit-box;
      display: -webkit-flex;
      display: -moz-box;
      display: -ms-flexbox;
      display: flex;
      .toPay-m-l {
        width: 253px;
        padding: 5px 0 5px 15px;
        background-color: #4A90E2;
        color: #fff;
        .inner-top {
          -webkit-box-flex: 0;
          -webkit-flex: none;
          -moz-box-flex: 0;
          -ms-flex: none;
          flex: none;
          display: -webkit-box;
          display: -webkit-flex;
          display: -moz-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-align: center;
          -webkit-align-items: center;
          -moz-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          &.is-deposit {
            margin-top: 10px;
          }
          .toPay-m-num {
            margin-right: 10px;
            padding-right: 7px;
            font-size: 14px;
            line-height: 16px;
            border-right: 1px solid #fff;
            span {
              font-size: 16px;
            }
          }
          .toPay-m-txt {
            font-size: 14px;
            line-height: 16px;
          }
          .toPay-m-price {
            font-size: 18px;
            line-height: 21px;
            font-weight: bold;
          }
        }
        .inner-bottom {
          font-size: 12px;
          color: #FDC00A;
          white-space: nowrap;
        }
      }
      .toPay-m-r {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        -moz-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        -moz-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        font-size: 14px;
        line-height: 1;
        color: #454545;
        letter-spacing: 1px;
        font-weight: bold;
        background: -webkit-gradient(linear, left top, right top, from(#FEBC10), to(#FAD961));
        background: -webkit-linear-gradient(left, #FEBC10, #FAD961);
        background: -moz-linear-gradient(left, #FEBC10, #FAD961);
        background: -o-linear-gradient(left, #FEBC10, #FAD961);
        background: linear-gradient(to right, #FEBC10, #FAD961);
      }
    }
}
.privacy-layout {
  font-size: 0;
  line-height: 1;
  position: absolute;
  top: 10px;
  right: 10px;
}
.guest-header {
  width: 375px;
  height: 82.5px;
  text-align: center;
  color: #FFFFFF;
  font-size: 12px;
  padding-top: 10px;
  margin-bottom: 8px;
  background-image: url("https://resource.rcclchina.com.cn/mobile/order/guest_info_top_bg.png");
  background-size: 100% 100%;
  & .logo {
    display: block;
    //width: 30px;
    height: 30px;
    margin: 0 auto;
  }
  & em {
    font-style:normal;
    font-size: 15px;
    font-weight: bold;
    margin: 0 3px;
  }

  & .row-1 {
    margin-top: 4px;
    line-height: 1;
    font-size: 12px;
  }
  & .row-2 {
    margin-top: 5px;
    letter-spacing: -1px;
    line-height: 1;
    font-size: 12px;
    & > span {
      font-size: 14px;
      font-weight: bold;
      margin: 0 3px;
      letter-spacing: 0;
      padding: 0 2px;
      border-bottom: 1px solid #FFFFFF;
    }
  }
}
.QIAOHU_CSS {
  background-size: 100% 100%;
  width: 113px;
  display: block;
  margin: 5px 0;
}
.PCP_GIFT_THEME_CSS {
  background-size: 100% 100%;
  width: 90px;
  display: block;
  margin: 5px 0;
}
.CUSTOM_THEME_CSS {
  background-size: 100% 100%;
  width: 90px;
  display: block;
  margin: 5px 0;
}
.hsbcBanner{
  width: 100%;
  height: 100px;
  margin: 10px 0;
  padding: 0 15px;
  &  .swiper-container {
    width: 100%;
    height: 100px;
    border-radius: 5px;
    overflow: hidden;
  }
  & .swiper-slide{
    width: 100%;
    height: 100px;
  }
  & img{
    width: 100%;
    height: 100px;
  }
}

.slow-height{
  height: 43px !important;
}
</style>
